import deletegif from "../../assets/gif/bin.gif";
import Modal from "../Modal/Modal";

const DeleteConfirmationModal = ({
  showModal,
  onClose,
  handleDelete,
  disable = false,
  fromPipeline = false
}) => {
  const buttonLabel = fromPipeline ? "Remove" : "Delete";

  return (
    <Modal width="450px" show={showModal} onClose={onClose}>
      <form className="py-3 text-center">
        <div className="flex justify-center mt-[-20px]">
          <img src={deletegif} alt="binimg" height={120} width={120} />
        </div>

        <div className="flex-1 mt-4 text-center w-30">
          <p className="head-1 dark-H font-bold">
            {fromPipeline ? "Remove Confirmation" : "Delete Confirmation"}
          </p>

          {/* hide description completely when coming from pipeline */}
          {!fromPipeline && (
            <p className="py-1 dark-M body-L">
              Kindly be aware that this action will result in a permanent deletion and cannot be undone.
            </p>
          )}
        </div>

        <div className="mt-6 flex justify-center">
          <button
            type="button"
            disabled={disable}
            style={{
              opacity: disable ? 0.5 : 1,
              cursor: disable ? "not-allowed" : ""
            }}
            onClick={handleDelete}
            className="save-button light-L head-5 red-bg-D px-[30px] py-[12px]"
          >
            {buttonLabel}
          </button>

          <button type="button" onClick={onClose} className="green-H body-N ml-5">
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default DeleteConfirmationModal;



